import mean from 'lodash/mean'
import round from 'lodash/round'

import { getReadabilityStatement } from '@pepper/utils/src/function/get_readability'
import type { ResearchReportDocument } from '@pepper/utils/src/types/seo'

export const metricsCopy = {
  page_length: {
    key: 'page_length',
    title: 'Word count',
    showProgressBar: true,
  },
  hx: {
    key: 'hx',
    title: 'Heading',
    showProgressBar: true,
  },
  a: {
    key: 'a',
    title: 'Links',
    showProgressBar: true,
  },
  readability_ease: {
    key: 'readability_ease',
    title: 'Readability Grade',
    showProgressBar: false,
  },
}

export function renderMetricValue({
  key,
  min,
  max,
  value,
}: {
  key: string
  min: number
  max: number
  value: number
}) {
  if (min === 0 && max === 0) return { goal: null, value: null }

  if (key === 'page_length') {
    return {
      // round to nearest 10
      goal: renderMetricRange(round(min, -1), round(max, -1)),
      value: value.toString(),
    }
  }

  if (key === 'readability_ease') {
    return {
      goal: getReadabilityStatement(mean([min, max])).level,
      value: getReadabilityStatement(value).level,
    }
  }

  return {
    goal: renderMetricRange(min, max),
    value,
  }
}

export function renderMetricRange(min: string | number, max: string | number) {
  if (min === max) return min
  return `${min}-${max}`
}

export function getProgressColor(
  percentage: number,
  options?: { min: number; max: number; value: number }
) {
  let color = null

  if (!percentage) color = 'var(--color-gray-200)'
  else if (percentage < 33) color = 'var(--color-orange-700)'
  else if (percentage < 66) color = 'var(--color-yellow-600)'
  else color = 'var(--color-green-600)'

  if (options && options.value !== 0 && options.value >= options.min)
    color = 'var(--color-green-600)'

  return {
    color,
    bg: `linear-gradient(to right, ${color} 0% ${percentage}%, var(--color-gray-200) ${percentage}% 100%)`,
  }
}

export function initializeMetricsState(
  report?: ResearchReportDocument
): Record<string, { min: number | null; max: number | null; value: number }> {
  return {
    page_length: {
      min: report?.page_length.min ?? null,
      max: report?.page_length.max ?? null,
      value: 0,
    },
    readability_ease: {
      min: report?.readability_ease.min ?? null,
      max: report?.readability_ease.max ?? null,
      value: 0,
    },
    hx: {
      min: report?.element_counts.hx.min ?? null,
      max: report?.element_counts.hx.max ?? null,
      value: 0,
    },
    a: {
      min: report?.element_counts.a.min ?? null,
      max: report?.element_counts.a.max ?? null,
      value: 0,
    },
  }
}
